export const capitalize = (s: string): string =>
  s ? s[0].toUpperCase() + s.slice(1).toLowerCase() : '';

export const toSentenceCase = (s: string) =>
  s
    .split('_')
    .filter((x) => x.length > 0)
    .map(capitalize)
    .join(' ');
